/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { createKey } from "shared/utils";
import { findElement } from "store/selectors/pageSelector";
import Collapse from "./Collapse";
import OptionItem from "./OptionItem";

const IconList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0 0 0 15px;
  margin: 10px 0 0 15px;
  list-style: none;
  border-left: 1px dashed #b0b0b0;
`;

const SelectItem = styled.li`
  position: relative;
  &:before {
    content: "";
    display: block;
    position: absolute;
    left: -14px;
    top: calc(50% - 1px);
    width: 14px;
    border-bottom: 1px dashed #b0b0b0;
  }
  &:last-child {
    &:after {
      content: "";
      position: absolute;
      display: block;
      height: 50%;
      top: 50%;
      width: 2px;
      background-color: #f9f9f9;
      left: -16px;
    }
  }
`;

class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.currentValue,
    };
  }

  /**
   * When component gets updated, check if the options changed.
   * If they did, check if the current value exists within the
   * new options, if it does, it's okay, we don't need to do anything
   * but if it doesn't exist, get the first option from the new
   * options and set it's value as the one currently selected.
   */
  componentDidUpdate() {
    const options = this.getOptions();
    const { currentValue } = this.props;
    const selected = options.find((opt) => opt.value === currentValue);
    if (!selected) {
      const { updaterFn, name } = this.props;
      const newValue = options[0].value;
      this.setState({ value: newValue });
      updaterFn({ prop: name, value: newValue });
    }
  }

  /**
   * Replaces string templates with variables values and return it
   *
   * @param {Object} source Source object containing the properties
   * @return {String} Resulting string
   */
  applyTemplatedStrings = (source) => {
    const { selectedText, locale } = this.props;
    const matches = [...selectedText.matchAll(/\$\{(\w*)\}/gi)];
    return matches
      .map((match) => {
        const key = match[1];
        let value = source[key] ? source[key] : "";
        // TODO: I18n
        if (key === "label") {
          value = typeof value === "string" ? value : value[locale];
        }
        return value;
      })
      .join(" ");
  };

  handleChange = (value) => {
    const { updaterFn, name } = this.props;
    this.setState({ value });
    updaterFn({ prop: name, value });
  };

  getRef = () => {
    const { value } = this.state;
    const { options, selectedText, locale } = this.props;
    const selected = options.find((opt) => opt.value === value);

    // If we're using selectedText, apply the template strings
    // and return the value.
    if (selectedText) {
      return this.applyTemplatedStrings(selected);
    }

    const { label, suffix } = selected;
    const labelText = typeof label === "string" ? label : label[locale];
    return `${labelText}${suffix ? ` ${suffix}` : ""}`;
  };

  getOptions = () => {
    const { options, elementKey, findElement } = this.props;
    const element = findElement(elementKey);
    const { props } = element;
    return options.filter((option) => {
      if (option.condition) {
        return eval(option.condition);
      }
      return true;
    });
  };

  render() {
    const { label, locale, opened, tooltip } = this.props;
    const { value } = this.state;

    const options = this.getOptions();

    return (
      <Collapse
        label={label}
        tooltip={tooltip}
        locale={locale}
        propRef={!opened && this.getRef()}
        visible={opened}
      >
        <IconList>
          {options.map((option) => {
            return (
              <SelectItem key={createKey()}>
                <OptionItem
                  {...option}
                  locale={locale}
                  selected={value}
                  onClick={this.handleChange}
                />
              </SelectItem>
            );
          })}
        </IconList>
      </Collapse>
    );
  }
}

const mapStateToProps = (state) => ({
  findElement: (key) => findElement(state, key),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Select);
